import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

//Components
import { Grid } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import Typography from 'components/CncUI/Typography';
import Link from 'components/CncUI/Link';

import support from 'constants/config/support';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  footer: {
    margin: '40px auto 120px auto',
    width: 576,
    [breakpoints.down('sm')]: {
      width: '100%',
      paddingBottom: 40,
    },
    textAlign: 'center',
  },
  iconContainer: {
    display: 'inline-block',
    height: 20,
    width: 20,
    borderRadius: '50%',
    backgroundColor: palette.cncUI.primary.gray['+2'],
    marginRight: spacing(1),
    marginLeft: spacing(1),
  },
  icon: {
    display: 'inline-block',
    fontSize: 16,
    color: palette.mycc.white,
    padding: 2,
  },
  privacy: {
    maxWidth: 576,
    margin: '0 auto 58px auto',
    paddingBottom: spacing(10),
    textAlign: 'center',
    '& .cncui-typography': {
      color: palette.cncUI.primary.gray['+3'],
    },
    [breakpoints.down('sm')]: {
      maxWidth: 500,
      margin: '0 auto 48px auto',
    },
    [breakpoints.only('xs')]: {
      maxWidth: 303,
    },
  },
  noPadding: {
    width: 'auto',
    margin: 0,
    paddingTop: spacing(1),
  },
  title: {
    fontWeight: 500,
    color: palette.cncUI.primary.gray['+2'],
    paddingBottom: 8,
  },
  hugRight: {
    color: palette.cncUI.primary.gray['+2'],
    textAlign: 'right',
    padding: '0 12px 16px 12px',
    [breakpoints.down('sm')]: {
      paddingBottom: 8,
      textAlign: 'center',
    },
  },
  hugLeft: {
    color: palette.cncUI.primary.gray['+2'],
    textAlign: 'left',
    padding: '0 12px 16px 12px',
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  label: {
    alignSelf: 'center',
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [breakpoints.down('sm')]: {
      justifyContent: 'center',
      alignContent: 'flex-end',
    },
  },
  reverse: {
    justifyContent: 'flex-start',
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'center',
    },
  },
  short: {
    margin: 0,
  },
  divider: {
    width: 64,
    height: 0,
    border: '1px solid #C6C6C6',
    marginBottom: 16,
  },
  subHeader: {
    marginBottom: 4,
    [breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  },
}));

const SupportFooter = props => {
  const classes = useStyles();
  const { showPrivacy, whichSupport = 'helpDesk', variant, title } = props;
  const supportInfo =
    support && whichSupport ? support[whichSupport] : support.helpDesk;
  const isHelpDesk = whichSupport === 'helpDesk';
  const supportInfo2 = isHelpDesk ? support.mediaServices : null;
  let whichClasses;
  switch (variant) {
    case 'box':
      whichClasses = clsx(classes.footer, classes.noPadding);
      break;
    case 'default':
    default:
      whichClasses = classes.footer;
      break;
  }

  return (
    <Grid container className={whichClasses} spacing={0}>
      <Grid item xs={12}>
        <Typography className={classes.title} variant="h6">
          {title ? title : `Contact ${supportInfo.title} for Assistance`}
        </Typography>
      </Grid>
      {isHelpDesk && supportInfo?.subHeader && (
        <Grid item xs={12}>
          <Typography variant="caption" noMargin className={classes.subHeader}>
            {supportInfo?.subHeader}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} md={6} className={classes.hugRight}>
        <div className={classes.labelContainer}>
          <div className={classes.iconContainer}>
            <PhoneIcon className={classes.icon} />
          </div>
          <span className={classes.label}>
            <Typography className={classes.short}>Phone</Typography>
          </span>
        </div>
        <Typography style={{ marginBottom: 0 }}>
          <Link
            href={supportInfo && supportInfo.phone && supportInfo.phone.link}
          >
            {supportInfo && supportInfo.phone && supportInfo.phone.display}
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} className={classes.hugLeft}>
        <div className={clsx(classes.labelContainer, classes.reverse)}>
          <span className={classes.label}>
            <Typography className={classes.short}>Email</Typography>
          </span>
          <div className={classes.iconContainer}>
            <MailIcon className={classes.icon} />
          </div>
        </div>{' '}
        <Typography style={{ marginBottom: 0 }}>
          <Link
            href={supportInfo && supportInfo.email && supportInfo.email.link}
          >
            {supportInfo && supportInfo.email && supportInfo.email.display}
          </Link>
        </Typography>
      </Grid>
      {isHelpDesk && supportInfo2?.title && (
        <>
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <div className={classes.divider} />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="caption"
              noMargin
              className={classes.subHeader}
            >
              {supportInfo2?.title}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} className={classes.hugRight}>
            <div className={classes.labelContainer}>
              <div className={classes.iconContainer}>
                <PhoneIcon className={classes.icon} />
              </div>
              <span className={classes.label}>
                <Typography className={classes.short}>Phone</Typography>
              </span>
            </div>
            <Typography>
              <Link href={supportInfo2?.phone?.link}>
                {supportInfo2?.phone?.display}
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} className={classes.hugLeft}>
            <div className={clsx(classes.labelContainer, classes.reverse)}>
              <span className={classes.label}>
                <Typography className={classes.short}>Email</Typography>
              </span>
              <div className={classes.iconContainer}>
                <MailIcon className={classes.icon} />
              </div>
            </div>{' '}
            <Typography>
              <Link href={supportInfo2?.email?.link}>
                {supportInfo2?.email?.display}
              </Link>
            </Typography>
          </Grid>
        </>
      )}
      {showPrivacy && (
        <Grid item className={classes.privacy}>
          <Typography variant="caption" noMargin>
            The privacy and security of your data is important to us. We use
            128-bit encryption to keep your data safe and will never sell your
            data to any third-parties.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SupportFooter;
